import { createClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * Cliente Supabase para frontend.
 *
 * IMPORTANTE: usa SIEMPRE la ANON_KEY (no SERVICE_ROLE_KEY).
 * La SERVICE_ROLE_KEY solo se usa en código servidor (edge functions, jobs),
 * NUNCA en este cliente accesible al navegador.
 *
 * La validación de las env vars se hace en src/lib/env.ts con Zod.
 */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
